import { TankSupplySelect } from '@components/Reports/TankSupplyDefaults/ApplyDefaultsDrawer/TankSupplySelect/TankSupplySelect'
import { GraviGrid, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Drawer } from 'antd'
import React, { useMemo } from 'react'

export function ApplyDefaultsDrawer({
  setIsBulkChangeVisible,
  isBulkChangeVisible,
  columnDefs,
  selectedRows,
  onDrawerSave,
}) {
  const drawerColumnDefs = useMemo(() => {
    const columnCopy = [...columnDefs]
    columnCopy[0] = {
      ...columnCopy[0],
      checkboxSelection: false,
      headerCheckboxSelection: false,
      headerCheckboxSelectionFilteredOnly: false,
    }
    columnCopy.pop()
    return columnCopy
  }, [columnDefs])

  return (
    <Drawer
      placement='bottom'
      onClose={() => setIsBulkChangeVisible(false)}
      visible={isBulkChangeVisible}
      title='Bulk Apply Defaults'
      height='95vh'
      bodyStyle={{ padding: '0px', background: 'var(--bg-2)' }}
      destroyOnClose
    >
      <Vertical flex='1'>
        <div className='p-3  bg-theme2 bg-3'>
          <Texto category='p2' appearance='white'>
            <b>Selected Tanks ({selectedRows.length}) - </b> You have selected the following rows to apply supply
            defaults/overrides:
          </Texto>
        </div>
        <div className='p-3' style={{ flex: 1 }}>
          <GraviGrid
            agPropOverrides={{
              columnDefs: drawerColumnDefs,
              getRowId: (row) => row.data?.key,
              getRowHeight: (params) => (params.data?.tank_supply_override ? 90 : 50),
            }}
            rowGroupPanelShow='never'
            storageKey='tank-strategy-bulk-change'
            rowData={selectedRows}
          />
        </div>
        <div
          style={{
            background: 'var(--bg-3)',
            width: '100%',
            maxHeight: '60%',
            minHeight: '60%',
            alignSelf: 'center',
            margin: -15,
          }}
          className=' bordered round-border'
        >
          <TankSupplySelect onDrawerSave={onDrawerSave} selectedRows={selectedRows} />
        </div>
      </Vertical>
    </Drawer>
  )
}
